module.exports = __webpack_public_path__ + "img/circlesLogin.740dbb9b.svg";